import React, { useState, useEffect, useContext } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { HiOutlineAdjustments } from 'react-icons/hi';
import Navbar from '../component/Navbar';
import Filter from '../component/Filter';
import Footer from '../component/footer';
import Categories from '../component/Categories';
import ProductGrid from '../component/ProductGrid';
import Pager from '../component/Pager';
import { ProductContext } from '../context/ProductContext';

const Layout = ({ userData }) => {
  const location = useLocation();
  const { products, loading, total } = useContext(ProductContext);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [showFilters, setShowFilters] = useState(false);

  const isListingRoute =
    location.pathname === '/' || location.pathname === '/products' || location.pathname.startsWith('/category/');
  const isHome = location.pathname === '/';

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
      if (window.innerWidth > 768) setShowFilters(true);
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className="flex min-h-screen flex-col bg-gray-50">
      <Navbar />

      {isListingRoute && <Categories />}

      {isHome && (
        <div className="bg-gradient-to-br from-brand-700 to-brand-500 px-4 py-10 text-white sm:px-6 sm:py-14">
          <div className="mx-auto max-w-7xl">
            <h1 className="text-2xl font-extrabold sm:text-4xl">Everything you need, all in one store</h1>
            <p className="mt-2 max-w-xl text-sm text-brand-100 sm:text-base">
              Great deals on electronics, fashion, beauty and more — new arrivals every day.
            </p>
          </div>
        </div>
      )}

      {isListingRoute && isMobile && (
        <button
          onClick={() => setShowFilters(!showFilters)}
          className="mx-4 mt-3 flex items-center justify-center gap-2 rounded-lg border border-gray-300 bg-white py-2 text-sm font-medium text-gray-700 shadow-sm sm:hidden"
        >
          <HiOutlineAdjustments size={18} />
          {showFilters ? 'Hide Filters' : 'Show Filters'}
        </button>
      )}

      <div className="mx-auto flex w-full max-w-7xl flex-1 flex-col gap-6 px-4 py-6 sm:px-6 md:flex-row">
        {isListingRoute && (!isMobile || showFilters) && (
          <aside className="w-full shrink-0 rounded-xl border border-gray-200 bg-white p-4 md:w-64">
            <h2 className="mb-3 text-base font-bold text-gray-900">Filters</h2>
            <Filter />
          </aside>
        )}

        <main className="min-w-0 flex-1">
          {isHome ? (
            <>
              <div className="mb-4 flex items-center justify-between">
                <p className="text-sm text-gray-500">{total} products</p>
              </div>
              <ProductGrid products={products} loading={loading} />
              <Pager />
            </>
          ) : (
            <Outlet context={userData} />
          )}
        </main>
      </div>

      <Footer />
    </div>
  );
};

export default Layout;
